import React from 'react';
import { useAuth } from '../contexts/AuthContext';

// CTA Banner component - Promotional banner above footer
const CTABanner = () => {
  const { login } = useAuth();

  // Handle button click - same as login button on login page
  const handleStartTrial = () => {
    login();
  };

  return (
    <section className="cta-banner">
      <div className="cta-banner-content">
        <h2 className="cta-banner-heading">Ready to Transform Your Jewelry Photography?</h2>
        <p className="cta-banner-subtitle">Join thousands of jewelry brands already using Photoshoot AI</p>
        <button className="cta-banner-button" onClick={handleStartTrial}>
          Start Your Free Trial Now
        </button>
        <p className="cta-banner-disclaimer">No credit card required • 10 free credits • Instant access</p>
      </div>
    </section>
  );
};

export default CTABanner;

